import './styles.css';

const Loader = () => (
    <div className='wrapper' data-title='dot-pulse'>
        <div className='stage'>
            <div className='dot-pulse'></div>
        </div>
    </div>
);

export default Loader;
